import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ControlOnOffIcon = ({ color, ...rest }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorSuccess;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="control-on-off-icon"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1754 13.175C21.2268 12.8 21.2525 12.4125 21.2525 12C21.2525 11.6 21.2268 11.2 21.1626 10.825L23.7713 8.85C24.0026 8.675 24.0668 8.3375 23.9255 8.0875L21.4581 3.9375C21.3039 3.6625 20.9827 3.575 20.6999 3.6625L17.6286 4.8625C16.9861 4.3875 16.305 3.9875 15.5468 3.6875L15.0842 0.5125C15.0328 0.2125 14.7758 0 14.4673 0H9.53266C9.22425 0 8.98008 0.2125 8.92868 0.5125L8.46605 3.6875C7.70786 3.9875 7.01392 4.4 6.38424 4.8625L3.31292 3.6625C3.0302 3.5625 2.70893 3.6625 2.55472 3.9375L0.100236 8.0875C-0.0539726 8.35 -0.00256973 8.675 0.254445 8.85L2.86314 10.825C2.79889 11.2 2.74748 11.6125 2.74748 12C2.74748 12.3875 2.77319 12.8 2.83744 13.175L0.228743 15.15C-0.00256973 15.325 -0.0668233 15.6625 0.0745346 15.9125L2.54187 20.0625C2.69608 20.3375 3.01735 20.425 3.30006 20.3375L6.37139 19.1375C7.01392 19.6125 7.69501 20.0125 8.4532 20.3125L8.91583 23.4875C8.98008 23.7875 9.22425 24 9.53266 24H14.4673C14.7758 24 15.0328 23.7875 15.0713 23.4875L15.5339 20.3125C16.2921 20.0125 16.9861 19.6125 17.6158 19.1375L20.6871 20.3375C20.9698 20.4375 21.2911 20.3375 21.4453 20.0625L23.9126 15.9125C24.0668 15.6375 24.0026 15.325 23.7584 15.15L21.1754 13.175Z"
        fill={token.colorBorder}
      />
      <circle cx="12" cy="12" r="7" fill={currentColor} />
      <g clipPath="url(#clip0_24061_68319)">
        <path
          d="M11.9311 19.3793C16.0446 19.3793 19.3793 16.0446 19.3793 11.9311C19.3793 7.81749 16.0446 4.48279 11.9311 4.48279C7.81749 4.48279 4.48279 7.81749 4.48279 11.9311C4.48279 16.0446 7.81749 19.3793 11.9311 19.3793Z"
          stroke={token.colorBgBase}
          strokeWidth="1.02621"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0544 14.4605C16.0828 14.4605 16.9165 13.4879 16.9165 12.2881C16.9165 11.0883 16.0828 10.1157 15.0544 10.1157C14.026 10.1157 13.1923 11.0883 13.1923 12.2881C13.1923 13.4879 14.026 14.4605 15.0544 14.4605Z"
          stroke={token.colorBgBase}
          strokeWidth="1.02621"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.22681 10.1157V14.4605"
          stroke={token.colorBgBase}
          strokeWidth="1.02621"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.88196 15.9088L12.3647 7.63293"
          stroke={token.colorBgBase}
          strokeWidth="1.02621"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24061_68319">
          <rect width="19.8621" height="19.8621" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ControlOnOffIcon;
